import React from 'react';
import styled from 'styled-components';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';

// Components
import CheckMark from '../../../../../../common/src/components/CheckMark';

interface Props {
  title: string;
  Icon: React.ReactElement;
  value: boolean;
  onSelected: () => void;
}

const SingleMultiSelectInput: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  Icon,
  value,
  onSelected,
  ...otherProps
}) => {
  return (
    <Wrapper
      data-test-id="ProdFac_SingleMultiSelectInput"
      onClick={onSelected}
      {...otherProps}
    >
      <IconWrapper checked={value}>
        {Icon}
        {value && <StyledIconCheckmark />}
      </IconWrapper>
      <Title>{title}</Title>
    </Wrapper>
  );
};

const StyledIconCheckmark = styled(CheckMark)`
  position: absolute;
  top: -1.6rem;
  right: -1.6rem;
`;

const Title = styled.h5`
  width: 100%;
  font-size: 1.8rem;
  margin-top: 1.6rem;
  text-align: center;
  height: 4rem;
  font-weight: 500;
`;

const IconWrapper = styled.div<{ checked?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 0 0 1px rgba(40, 41, 61, 0.04), 0 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 10px;
  border: ${({ checked, theme }) =>
    checked ? `2px solid ${theme.primary[500]}` : 'none'};
  padding: ${({ checked }) => (checked ? 'calc(3.2rem - 2px)' : '3.2rem')};

  &:first-child {
    height: 12rem;
    width: 100%;
  }

  background: #fff;
  transition: background-color 0.2s;
  &:hover {
    background: #fafafa;
  }

  ${mq.tablet} {
    padding: ${({ checked }) => (checked ? 'calc(4rem - 2px)' : '4rem')};
  }
`;

const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default SingleMultiSelectInput;
